export default {
  english: {
    link: {
      href: 'special',
      label: 'Find out now',
    },
  },
  french: {
    link: {
      href: 'special',
      label: 'Voir les derniers articles',
    },
  },
  arabic: {
    link: {
      href: 'مميز',
      label: 'اكتشف الآن',
    },
  },
  hebrew: {
    link: {
      href: 'מיוחד',
      label: 'גלה עכשיו',
    },
  },
  persian: {
    link: {
      href: 'خاص',
      label: 'اکنون دریابید',
    },
  },
}
